import React, { useEffect } from 'react';
import { ISkleraItem } from '../../utils/interface';
import Card from './Card';

import { skleraSDK } from '@sklera/sdk';
import { downloadFile } from '../../utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Button, Paragraph } from '../Viewer';

const DropDown = ({
    downloadItem,
    isPublicApp,
}: {
    downloadItem: ISkleraItem;
    isPublicApp: boolean;
}) => {
    const [open, setOpen] = React.useState(false);
    const drop = React.useRef(null);
    const [downloadUrl, setDownloadUrl] = React.useState<string | null>();

    useEffect(() => {
        setDownloadUrl(null);
        if (downloadItem?._id) {
            skleraSDK.getPublicDownloadLink(downloadItem._id, (err: any, url: string) => {
                if (!err && url) {
                    setDownloadUrl(url);
                }
            });
        }
    }, [downloadItem?._id]);

    function clickOpenButton() {
        if (isPublicApp) {
            downloadFile(downloadItem);
        } else {
            if (open) {
                setOpen(false);
            } else {
                skleraSDK.logEvent(
                    'TOUCH_ACTION_GENERIC',
                    { itemId: downloadItem._id, action: 'mnb_open_qr_code' },
                    (re: any) => {
                        console.log(re);
                    }
                );
                setOpen(true);
            }
        }
    }

    return (
        <div className="dropdown" ref={drop}>
            <Button onClick={clickOpenButton}>
                <FontAwesomeIcon icon={faDownload} />
                <Paragraph>Download</Paragraph>
            </Button>
            <Card downloadItem={downloadUrl || ''} open={!!(open && downloadUrl)} />
        </div>
    );
};

export default DropDown;
